/**
 * Converts a string representing a money (or percentage) amount to a float.
 * Perfect to parse the values emitted by our MaskedInputs.
 *
 * e.g.
 *  3,333,333 => 3333333
 *  4,555.23 => 4555.23
 */
export const parseMaskedInputString = (maskedInputString: string): number =>
  parseFloat(maskedInputString.replace(/,/g, ''));
